module.exports = __webpack_public_path__ + "img/multi-reviews-carousel-mazda.5a68e3a8.png";